module.exports = __webpack_public_path__ + "img/promo-jul-2020.7dd62ef3.png";